'use client';

import { Icons } from '@/components/icons';
import { useIntegrationStatusPageData } from '@/app/settings/organization/integrations/hooks/use-integration-status-page-data';
import { buttonVariants } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { usePerms } from '@/hooks/usePerms';
import { cn } from '@/lib/cn';
import { Urls } from '@/lib/urls';
import Link from 'next/link';

export function IntegrationAttentionBanner() {
  const { canView, canCreate, canUpdate, canDelete } = usePerms(
    'integrationuseragent'
  );
  const canDoItAll = canView && canCreate && canUpdate && canDelete;
  const { attentionCount, isLoading } = useIntegrationStatusPageData({
    includeLastSync: false,
    enabled: canDoItAll,
  });

  if (!canDoItAll || isLoading || attentionCount === 0) {
    return null;
  }

  return (
    <Card className='mb-6 gap-3 px-4 py-3'>
      <div className='flex flex-wrap items-center justify-between gap-3'>
        <div className='flex min-w-0 items-center gap-3'>
          <div className='flex size-10 shrink-0 items-center justify-center rounded-lg bg-destructive-subtle'>
            <Icons.warning className='size-5 text-destructive' />
          </div>
          <div className='min-w-0 flex-1'>
            <span className='block truncate text-sm font-medium'>
              {attentionCount === 1
                ? '1 integration behöver din uppmärksamhet'
                : `${attentionCount} integrationer behöver din uppmärksamhet`}
            </span>
            <span className='block text-xs text-muted-foreground'>
              {attentionCount === 1 ? 'Åtgärd' : 'Åtgärder'} krävs för att
              synken ska fortsätta utan avbrott
            </span>
          </div>
        </div>
        <Link
          prefetch={false}
          href={Urls.settings.organization.integrations}
          className={cn(
            buttonVariants({ variant: 'default', size: 'sm' }),
            'flex items-center gap-2'
          )}
        >
          <span>{attentionCount === 1 ? 'Visa åtgärd' : 'Visa åtgärder'}</span>
          <Icons.arrowRight className='size-4' />
        </Link>
      </div>
    </Card>
  );
}
